import { useState, useEffect, useCallback } from 'react';

export function useAsyncAutocomplete(inputValue, searchFn, opts = {}) {
  const { minLength = 1 } = opts;
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const runSearch = useCallback(async () => {
    const term = (inputValue || '').trim();
    if (term.length < minLength) {
      setOptions([]);
      return;
    }
    setLoading(true);
    try {
      const result = await searchFn(term);
      setOptions(Array.isArray(result) ? result : []);
    } catch (err) {
      console.error('[useAsyncAutocomplete]', err);
      setOptions([]);
    } finally {
      setLoading(false);
    }
  }, [inputValue, minLength, searchFn]);

  useEffect(() => {
    const t = setTimeout(runSearch, 300);
    return () => clearTimeout(t);
  }, [runSearch]);

  return { options, loading };
}
